import { render, staticRenderFns } from "./WsCol.vue?vue&type=template&id=7c0a1ecb&"
import script from "./WsCol.vue?vue&type=script&lang=js&"
export * from "./WsCol.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports